module.exports = __webpack_public_path__ + "img/added_bounces.4dfbbe5e.png";